export default "__VITE_ASSET__8782b06a__"